import type { SynthesisSessionRepository } from "../repositories/synthesis-session-repository"

export const makeAskStreamSynthesisSession =
  (repo: SynthesisSessionRepository) =>
  (sessionId: string, content: string, signal?: AbortSignal) =>
    repo.askStream(sessionId, content, signal)
